const headers = [
  {text:"", value: "actions"},
  { text: 'Mã ID', value: 'id', align: 'start', sortable: true },
  { text: 'Mã nhân viên', value: 'employeeCode' },
  { text: 'Tên nhân viên', value: 'employeeName' },
  { text: 'Phòng ban', value: 'departmentName' },
  { text: 'Bộ phận', value: 'divisionName' },
  { text: 'Ngày làm việc', value: 'workDate' },
  { text: 'Giờ làm cần xác nhận', value: 'worktime' },
  { text: 'Lý do', value: 'reasonTypeName' },
  { text: 'Ghi chú', value: 'note' },
  { text: 'Hình ảnh', value: 'imageUrl' },
  { text: 'Ngày tạo', value: 'createdAt', type: 'date' },
  { text: 'Quản lý trực tiếp', value: 'managerName' },
  { text: 'Nhân sự phụ trách', value: 'hrAdminName' },
  { text: 'Giám đốc nhân sự', value: 'hrManagerName' },
]
export default headers;